var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.products.length)?_c('div',{staticClass:"text-center fs-3 text-uppercase fw-light text-muted my-3"},[_vm._v(" "+_vm._s(_vm.$t("infos.select-filter"))+" ")]):_c('div',{staticClass:"products-grid"},_vm._l((_vm.products.filter((e) => !e.isFeatured)),function(product){return _c('product-card',{key:product.id,attrs:{"product":product}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }